import { Buffer } from "buffer";
const BackendUname = process.env.REACT_APP_BACKEND_API_USERNAME;
const BackendPwd = process.env.REACT_APP_BACKEND_API_PASSWORD;
export const slfserviceGeneralApiLink = process.env.REACT_APP_API_URL;
export const company = process.env.REACT_APP_COMPANY;
const slfserviceActionLink = process.env.REACT_APP_ACTION_PI_DATA_URL_2;

export const companyDefault = `${company}`;
export const items = "itemsApi";
export const glAccounts = "gLAccounts";
export const paymentTerms = "paymentTerms";
export const customers = "customers";
export const customerLedgerEntries = "customerLedgerEntries";
export const vendLedgerEntries = "vendLedgerEntries";
export const itemLedgerEntries = "itemLedgerEntries";
export const bankLedgerEntries = "bankLedgerEntries";
export const currencies = "currencies";
export const salesQuotes = "salesQuotes";
export const draftQuotes = "draftHeader";
export const draftQuoteLines = "draftLines";
export const salesquoteLines = "salesQuoteLines";
export const salesOrders = "salesOrders";
export const salesOrderLines = "salesOrderLines";
export const postedSalesCreditmemo = "postedSalesCreditmemo";
export const postedSalesCreditLines = "postedSalesCreditLines";
export const postedSalesInvoices = "postedSalesInvoices";
export const postedSalesInvoicesLines = "postedSalesInvoicesLines";
export const purchaseOrders = "purchaseOrders";
export const postedSalesShipment = "postedShipments";
export const postedSalesShipmentLines = "postedShipmentsLines";
export const documentAttachments = "documentAttachments";
export const salesComment = "salesComments";

// BME Module
export const fixedAssets = "fixedAssets";
export const workOrders = "workOrders";
export const workOrderSLines = "workOrderSLines";
export const workOrderTasks = "workOrderTasks";
export const bMEDisposalRequests = "bMEDisposalRequests";

// Action Calls
export const quotesAndOrders = "getCustomerQuotesandOrders";
export const getCustomerOrders = "getCustomerOrders";
export const getTotalReversals = "getTotalReversals";
export const getCustomerpayments = "getCustomerpayments";
export const getPostedInvoices = "getPostedInvoices";
export const getPostedShipments = "getPostedShipments";
export const printSalesQuotes = "printSalesQuotes";
export const confirmDraftQuote = "confirmDraftQuote";
export const reopenDraftQuote = "reopenDraftQuote";
export const confirmQuoteProcessing = "confirmQuoteProcessing";
export const reopenQuote = "reopenQuote";

// document attachment specifics
export const documentAttachment = `${slfserviceGeneralApiLink}documentAttachments`;
export const bMEDisposalRequest = `bMEDisposalRequests?${company}`;
export const DeleteBCLines = `${slfserviceActionLink}DeleteAllLines?${company}`;

export const base64backendtoken = Buffer.from(
  `${BackendUname}:${BackendPwd}`,
  "utf8",
).toString("base64");

// module.exports = {items, customers, glAccounts, paymentTerms, currencies, customerLedgerEntries, salesquoteLines};
